"use client";
import React, { useState } from "react";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
import {
  clickstreamForClicks,
  gaForCtaClicks,
  isWhatuni,
  oldGAForCtaClicks,
} from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants, GAConstants } from "@packages/shared-components/services/constants";
import ButtonLoader from "./ButtonLoader";
import { CLICLSREAM_VALUES as CS } from "@packages/constants/clickstream.const";
import { DataLayerGA4AttrType } from "@packages/lib/types/datalayerGA";

interface VisitWebsiteProps {
  enquiryProps: {
    subOrderItemId?: string | number;
    orderItemId: string | number;
    collegeId: string | number;
    qualCode?: string;
    websiteUrl?: string;
    [key: string]: any;
  };
  commonGAAttrs?: any;
  btnColor?: string;
  btnMinW?: string;
  btnSize?: string;
  clearing?: boolean;
  btnName?: string;
  commonOldGAAttrs?: any
}

const Visitwebsite = ({
  enquiryProps,
  commonGAAttrs,
  btnColor = "btn-grey",
  btnSize = "",
  btnMinW = "",
  clearing = false,
  btnName,
  commonOldGAAttrs
}: VisitWebsiteProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const csData: ClickstreamInterface = {
    CTATitle: ClickstreamConstants.visitWebsiteCTA,
    actionType: ClickstreamConstants.clickAction,
    eventType: clearing
      ? enquiryProps?.eventType
        ? enquiryProps?.eventType
        : CS.eventTypes.clearingVisitWebsite
      : CS.eventTypes.visitWebsite,

    functionalityName: enquiryProps?.functionalityName
      ? enquiryProps?.functionalityName
      : clearing
        ? "Clearing"
        : enquiryProps?.sponsoredListingFlag === "Y"
          ? ClickstreamConstants.sponsorListing
          : "VisitWebsite",
  };

  const handleVisitWebsite = async (e: any) => {
    setIsLoading(true);
    e.stopPropagation();
    e.preventDefault();
    try {
      const vwPayload = {
        suborderItemId: enquiryProps?.subOrderItemId,
        orderItemId: enquiryProps?.orderItemId,
        collegeId: enquiryProps?.collegeId,
        courseId: enquiryProps?.courseId,
        qualCode: enquiryProps?.qualCode,
        affiliateId: process.env.AFFILATE_ID,
      };
      if (commonGAAttrs?.study_mode) {
        commonGAAttrs.study_mode = enquiryProps?.studyMode;
      }
      if (sessionStorage.getItem("veppleProviders") && commonOldGAAttrs) {
        commonOldGAAttrs.data_label5 = "vepple_driven";
      }
      let response: any;
      if (enquiryProps?.websiteUrl)
        response = { ...enquiryProps, website: enquiryProps?.websiteUrl };
      else {
        response = await makeApiCall({
          url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
          method: "POST",
          queryParams: {},
          body: vwPayload,
          headers: {
            "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
          },
        });
      }
      const websiteUrl = response?.stdVisitWebsiteUrl || response?.website;
      if (websiteUrl) {
        csData.externalUrl = websiteUrl;
        enquiryProps.url = websiteUrl;
        enquiryProps.revenueValue = response?.websitePrice
        commonGAAttrs.click_text = csData.CTATitle
        gaForCtaClicks(
          enquiryProps,
          "visit_website",
          { ...commonGAAttrs },
          response.cpeFlag,
          ""
        );
        enquiryProps.event = "visit website"
        !(isWhatuni() && commonGAAttrs.page_grouping === "scholarship_pages") && oldGAForCtaClicks(
          enquiryProps,
          "Visit website",
          websiteUrl,
          `${clearing ? "clearing_" : ""}webclick`,
          { ...commonOldGAAttrs,data_label : "visit_website"},
          response.cpeFlag,
          ""
        );
        clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "", clearing);
        window.open(websiteUrl, "_blank");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching enquiry data:", error);
    }
  };

  return (
    <button
      type="button"
      className={`btn w-full flex items-center justify-center ${btnSize} ${btnColor} ${btnMinW}`}
      onClick={handleVisitWebsite}
    >
      <ButtonLoader isLoading={isLoading}>
        {btnName || ClickstreamConstants.visitWebsiteCTA}
      </ButtonLoader>
    </button>
  );
};

export default Visitwebsite;
